import { render, staticRenderFns } from "./AccRemoveDialog.vue?vue&type=template&id=eff44188"
import script from "./AccRemoveDialog.vue?vue&type=script&lang=ts"
export * from "./AccRemoveDialog.vue?vue&type=script&lang=ts"
import style0 from "./AccRemoveDialog.vue?vue&type=style&index=0&id=eff44188&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldSelect: require('/builds/project/wyffest/frontend/components/field/FieldSelect.vue').default,FieldTextarea: require('/builds/project/wyffest/frontend/components/field/FieldTextarea.vue').default,AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default})
